import styled from "styled-components";

export const ProductRowDetail = styled.div`
  color: var() (--p-color-text-primary);
  font-size: 16px;
  line-height: 20px;
  margin-bottom: auto;
  overflow: hidden;
  padding-top: 18px;
  text-overflow: ellipsis;
  white-space: initial;
  width: 50%;

  & span {
    font-size: inherit;
  }

  a {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const ProductRowDetailValueInline = styled(ProductRowDetail)`
  margin-left: 25px;
  padding-top: 5px;
  text-align: left;
  width: auto;
`;

export const ProductRowDetailValue = styled(ProductRowDetail)`
  text-align: right;
`;

export const HouseExtension = styled(ProductRowDetail)`
  width: 100%;
`;
